import {
  CreateUpdateFinanceDimensionMembershipDocument,
  EndFinanceDimensionMembershipDocument,
} from 'generated/resources/graphql'
import _ from 'lodash'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

import { SingleValueDimensionAssignment } from 'modules/finance/hooks/useEmployeeDimensionsAssignments'

const useDimensionAssignments = () => {
  const { company } = useCurrentSession()
  const [saveCustomDimensionAssignment] = useMutation(
    CreateUpdateFinanceDimensionMembershipDocument,
    { extractorFn: (data) => data.financeMutations.upsertFinanceCustomDimensionMembership }
  )

  const [endCustomDimensionAssignment] = useMutation(EndFinanceDimensionMembershipDocument, {
    extractorFn: (data) => data.financeMutations.endFinanceCustomDimensionMembership,
  })

  const saveDimensionAssignment = async (
    employeeId: number,
    dimension: SingleValueDimensionAssignment
  ) => {
    if (!dimension.assignmentValue) return false

    const variables = {
      employeeId: Number(employeeId),
      customDimensionValueId: Number(dimension.assignmentValue.id),
      companyId: company.id,
    }

    const response = await saveCustomDimensionAssignment({
      variables,
    })

    const result = handleResult(response, _.noop)
    return result.success
  }

  const endDimensionAssignment = async (membershipId: number) => {
    const variables = {
      id: membershipId,
      companyId: company.id,
    }

    const response = await endCustomDimensionAssignment({
      variables,
    })

    const result = handleResult(response, _.noop)
    return result.success
  }

  return {
    saveDimensionAssignment,
    endDimensionAssignment,
  }
}

export default useDimensionAssignments
